import type { ChatErrorCardProps } from "./types";

export function ChatErrorCard({ fallbackUrl, onRetry }: ChatErrorCardProps) {
  return (
    <div className="my-4 rounded-2xl border border-border bg-secondary/40 p-5 shadow-sm">
      <p className="mb-2 font-medium text-text">I&apos;m having trouble connecting right now</p>
      <p className="mb-4 text-sm text-text-secondary">
        You can continue using our guided experience while we get this sorted out.
      </p>
      <div className="flex flex-wrap gap-3">
        <a
          href={fallbackUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Continue on website (opens in new tab)"
          className="inline-flex items-center gap-2 rounded-full bg-accent px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-accent-hover"
        >
          Continue on website
          <span aria-hidden="true">&rarr;</span>
        </a>
        <button
          type="button"
          onClick={onRetry}
          className="inline-flex items-center rounded-full border border-border px-5 py-2.5 text-sm font-medium text-text-secondary transition-colors hover:bg-white cursor-pointer"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
